











































import {Component, Vue} from "vue-property-decorator";
import CategoryService, {CategoryDto, ICategory} from "@/services/category.service";

@Component({name: "Admin"})
export default class Admin extends Vue {
    private categoryService!: CategoryService;
    private categories: ICategory[] = [];
    private error = "";

    private editing: ICategory | null = null;
    private editingError = "";

    private category: CategoryDto = {
        category: "",
    }

    private mounted() {
        this.categoryService = new CategoryService();
        this.refresh();
    }

    private isEditing(category: any): boolean {
        // @ts-ignore
        return category && this.editing && category.id === this.editing.id;
    }

    private async refresh() {
        const res = await this.categoryService.get();
        if (res.success) this.categories = res.result;
    }

    private async createCategory() {
        const res = await this.categoryService.post(this.category);
        this.error = "";
        if (res.success) {
            this.category = {
                category: "",
            }
            this.refresh();
        } else {
            this.error = res.error;
        }
    }

    private async saveCategory() {
        if (!this.editing) throw new Error("Editing is null");
        const res = await this.categoryService.put(this.editing.id, this.editing);
        this.editingError = "";
        if (res.success) {
            this.editing = null;
            this.refresh();
        } else {
            this.editingError = res.error;
        }
    }

    private async deleteCategory(id: string) {
        await this.categoryService.delete(id);
        this.refresh();
    }
}
